import DefaultParameters from './defaultParameters';
import { CRITICAL, MEDIUM, LOW } from '../congestionLevels';
import { NETWORK_CONDITION_REASON } from '../../../../helpers/networkConditionConstants';

const createTimeBasedCongestionLevel = (customParams = {}) => {
  const params = {
    ...DefaultParameters,
    ...customParams,
  };
  let dangerZone = false;
  let dangerZoneStart;
  return {
    getLevel({ audioPacketLoss }) {
      if (audioPacketLoss < params.packetLossCriticalThreshold) {
        dangerZone = false;
        return { level: LOW, reason: NETWORK_CONDITION_REASON.NONE };
      }

      const currentTime = Date.now();
      if (!dangerZone) {
        dangerZoneStart = currentTime;
        dangerZone = true;
      }

      if (currentTime > dangerZoneStart + params.criticalCongestionPeriod) {
        return { level: CRITICAL, reason: NETWORK_CONDITION_REASON.PACKET_LOSS };
      }

      if (currentTime > dangerZoneStart + (params.criticalCongestionPeriod / 2)) {
        return { level: MEDIUM, reason: NETWORK_CONDITION_REASON.PACKET_LOSS };
      }

      return { level: LOW, reason: NETWORK_CONDITION_REASON.NONE };
    },
  };
};

export default createTimeBasedCongestionLevel;
